<div class="spinner-content">
    <content-loader name="bind_to_doctor_form"></content-loader>
    <div>
        <h3 mat-dialog-title>{{'Сбросить пароль'|translate}}</h3>
    </div>
    <div class="d-flex flex-column">

        <div  *ngIf="changePasswordForm">
            <ng-contaner [formGroup]="changePasswordForm">
                <div class="d-flex  flex-column">
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-label>{{'NEW_PASSWORD'|translate}}</mat-label>
                        <input formControlName="newPassword" matInput type="password">
                        <mat-error
                            *ngIf="changePasswordForm.get('newPassword').hasError('required') || changePasswordForm.get('newPassword').touched">
                            {{'NEW_PASSWORD_INVALID_MESSAGE'|translate}}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width" appearance="outline">
                        <mat-label>{{'CONFIRM_NEW_PASSWORD'|translate}}</mat-label>
                        <input formControlName="confirmNewPassword" matInput type="password">
                        <mat-error
                            *ngIf="changePasswordForm.get('confirmNewPassword').hasError('required') || changePasswordForm.get('confirmNewPassword').touched">
                            {{'CONFIRM_NEW_PASSWORD_INVALID_MESSAGE'|translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                
        
            </ng-contaner>
           
        </div>


        <div class="mt-auto">
            <div class="d-flex justify-content-end">
                <button class="pl-2" mat-raised-button color="primary" type="button"
                [disabled]="isLoading||changePasswordForm.invalid" (click)="setPassword()">
                {{'CHANGE_PASSWORD'|translate}}
            </button>
                <button class="pr-2" mat-stroked-button color="warn" (click)="dialogRef.close()"
                    tabindex="-1">{{'CLOSE'|translate}}</button>

            </div>
        </div>

    </div>
</div>